module.exports = __webpack_public_path__ + "img/step1.b61b7ff5.png";